const angularModule = angular.module('com.comtrade.shared.sharedModule', [
    'angularModalService',
    'dndLists',
    require('./ctxContentSwitcher/ctxContentSwitcher.module').name,
    require('./ctxGrid/ctxGrid.module').name,
    require('./ctxTableTree/ctxTableTree.module').name,
    require('./ctxTabs/ctxTabs.module').name,
    require('./ctxCarousel/ctxCarousel.module').name,
    require('./ctxDropdown/ctxDropdown.module').name
]);

angularModule.component('ctxNavigationBar', require('./ctxNavigationBar/ctxNavigationBar.component'));
angularModule.component('ctxNavigationMenu', require('./ctxNavigationMenu/ctxNavigationMenu.component'));
angularModule.component('basicTable', require('./basicTable/basicTable.component'));
angularModule.component('ctxBarChart', require('./ctxBarChart/ctxBarChart.component.js'));
angularModule.component('detailsList', require('./detailsList/detailsList.component'));
angularModule.component('btPagination', require('./basicTablePagination/basicTablePagination.component'));
angularModule.component('ctxDonut', require('./ctxDonut/ctxDonut.component'));
angularModule.component('ctxGraph', require('./ctxGraph/ctxGraph.component'));
angularModule.component('ctxNumberDisplay', require('./ctxNumberDisplay/ctxNumberDisplay.component'));
angularModule.directive('ctxResize', require('./utils/ctxResize.directive'));
angularModule.directive('ctxRightClick', require('./utils/ctxRightClick.directive'));
angularModule.component('ctxSideNavigation', require('./ctxSideNavigation/ctxSideNavigation.component'));
angularModule.component('ctxModal', require('./ctxModal/ctxModal.component'));
angularModule.component('ctxInput', require('./ctxInput/ctxInput.component'));
angularModule.component('ctxAppPanelToolbar', require('./ctxAppPanelToolbar/ctxAppPanelToolbar.component'));
angularModule.component('ctxToolbarButton', require('./ctxToolbarButton/ctxToolbarButton.component'));
angularModule.component('ctxMessageBox', require('./ctxMessageBox/ctxMessageBox.component'));
angularModule.component('ctxRadioButton', require('./ctxRadioButton/ctxRadioButton.component'));
angularModule.component('ctxRadioContainer', require('./ctxRadioContainer/ctxRadioContainer.component'));
angularModule.component('ctxSelect', require('./ctxSelect/ctxSelect.component'));
angularModule.component('ctxSearchBox', require('./ctxSearchBox/ctxSearchBox.component'));
angularModule.component('ctxTable', require('./ctxTable/ctxTable.component'));
angularModule.component('ctxTablePagination', require('./ctxTablePagination/ctxTablePagination.component'));
angularModule.directive('ctxTableResizer', require('./ctxTableResizer/ctxTableResizer.directive'));
angularModule.component('ctxTableSelection', require('./ctxTableSelection/ctxTableSelection.component'));
angularModule.component('fileUpload', require('./fileUpload/fileUpload.component'));
angularModule.directive('fileReader', require('./fileUpload/fileUpload.directive'));
angularModule.component('ctxCheckbox', require('./ctxCheckbox/ctxCheckbox.component'));
angularModule.directive('ctxDatepicker', require('./ctxDatepicker/ctxDatepicker.directive'));
angularModule.directive('ctxDisableCtrlClick', require('./utils/ctxDisableCtrlClick.directive'));
angularModule.component('ctxWidgetPanel', require('./ctxWidgetPanel/ctxWidgetPanel.component'));
angularModule.component('ctxProgressbar', require('./ctxProgressbar/ctxProgressbar.component'));
angularModule.component('ctxSwitchButton', require('./ctxSwitchButton/ctxSwitchButton.component'));
angularModule.component('ctxFiltersPanel', require('./ctxFiltersPanel/ctxFiltersPanel.component.js'));
angularModule.component('ctxTag', require('./ctxTag/ctxTag.component'));
angularModule.component('ctxTagsInput', require('./ctxTagsInput/ctxTagsInput.component'));
angularModule.component('ctxTagsDropdown', require('./ctxTagsDropdown/ctxTagsDropdown.component'));
angularModule.component('ctxTagsEnter', require('./ctxTagsEnter/ctxTagsEnter.component'));
angularModule.component('ctxClickableTags', require('./ctxClickableTags/ctxClickableTags.component'));
angularModule.component('ctxTooltip', require('./ctxTooltip/ctxTooltip.component'));
angularModule.component('ctxPercentageBar', require('./ctxPercentageBar/ctxPercentageBar.component'));
angularModule.directive('ctxCustomScrollBar', require('./utils/ctxCustomScrollBar.directive.js'));
angularModule.directive('ctxGridResizer', require('./ctxGridResizer/ctxGridResizer.directive'));
angularModule.directive('ctxTooltip', require('./utils/tooltip.directive'));
angularModule.component('ctxWeeklyScheduler', require('./ctxWeeklyScheduler/ctxWeeklyScheduler.component'));
angularModule.component('ctxFileExplorer', require('./ctxFileExplorer/ctxFileExplorer.component'));
angularModule.component('minimizeButtonToggle', require('./minimizeButtonToggle/minimizeButtonToggle.component'));
angularModule.component('ctxPivotTable', require('./ctxPivotTable/ctxPivotTable.component'));
angularModule.component('ctxPivotTagFilter', require('./ctxPivotTable/ctxPivotTagFilter.component'));
angularModule.component('ctxExport', require('./ctxExport/ctxExport.component'));

angularModule.service('donutService', require('./ctxDonut/ctxDonut.service'));
angularModule.service('dialogService', require('./utils/dialog.service.js'));
angularModule.service('translateService', require('./utils/translate.service.js'));
angularModule.service('notificationService', require('./ctxNotification/ctxNotification.service.js'));
angularModule.service('sharedHelperService', require('./utils/sharedHelper.service.js'));

angularModule.filter('translate', require('./utils/translate.filter'));
angularModule.animation('.ctx-slide-toggle', require('./utils/ctxSlideToggle.animation'));

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/shared/shared.module.js